import type { ApplicationForm } from './form.types'

const form: ApplicationForm = {
  type: 'newLoanApplication',
  sections: [
    {
      name: 'Låntagare',
      description: 'Lägg till uppgifter om huvudlåntagaren och eventuella medlåntagare.',
      questions: ['Borrowers'],
    },
    {
      name: 'Objekt',
      description: 'Fyll i uppgifter om bostaden som ansökan gäller.',
      questions: [
        'CollateralType',
        'NewProduction',
        'CollateralAddress',
        'CollateralValuation',
        'CollateralMonthlyFee',
        'CollateralApartmentDetails',
        'CollateralSize',
      ],
    },
    {
      name: 'Ansökt lånebelopp',
      description: 'Ange lånebelopp, prioritet och övriga grunduppgifter för ansökan.',
      questions: ['LoanAmount', 'BridgeLoan', 'DepositLoan', 'HighPriority'],
    },
    {
      name: 'Hushåll',
      description: 'Lägg till personer i hushållet.',
      questions: ['HouseholdChildren'],
    },
    {
      name: 'Tillgångar & skulder',
      description: 'Lägg till hushållets fordon, tillgångar, lån och andra bostäder.',
      questions: ['HouseholdCars', 'CapitalAssets', 'OtherLoans', 'OtherProperties'],
    },
    {
      name: 'Kommentar',
      description: 'Lägg till intern information som är relevant för handläggningen.',
      questions: ['Comment'],
    },
  ],
}

export default form
